import React from 'react';

import { ContentfulImage, Props as ImageProps } from 'components/Contentful/ContentfulImage';
import { Video, Props as VideoProps } from 'components/Contentful/Video';

type BasicMediaProps = ImageProps & VideoProps;

const BasicMedia = React.forwardRef<ContentfulImage | Video, BasicMediaProps>(
  ({ asset, video, ...otherProps }, ref) => {
    if (video) {
      return <Video ref={ref as React.Ref<Video>} asset={asset} video={video} {...otherProps} />;
    }

    return <ContentfulImage ref={ref as React.Ref<ContentfulImage>} asset={asset} {...otherProps} />;
  },
);

type BasicMediaType = typeof BasicMedia;

export { BasicMediaProps, BasicMedia, BasicMediaType };
